import React from 'react';

export const Card = ({ children, className = "" }) => {
  return (
    <div className={`spera-card max-w-full overflow-hidden rounded-2xl bg-white p-6 ${className}`}>
      {children}
    </div>
  );
};
